var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcNavHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 2.29004C5.74313 2.29004 2.29199 5.74118 2.29199 9.99837C2.29199 14.2555 5.74313 17.7067 10.0003 17.7067C14.2575 17.7067 17.7087 14.2555 17.7087 9.99837C17.7087 5.74118 14.2575 2.29004 10.0003 2.29004ZM1.04199 9.99837C1.04199 5.05082 5.05278 1.04004 10.0003 1.04004C14.9479 1.04004 18.9587 5.05082 18.9587 9.99837C18.9587 14.946 14.9479 18.9567 10.0003 18.9567C5.05278 18.9567 1.04199 14.946 1.04199 9.99837Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99341 6.45898C9.18557 6.45898 8.53216 7.11274 8.53216 7.91732C8.53216 8.7219 9.18557 9.37565 9.99341 9.37565C10.8013 9.37565 11.4547 8.7219 11.4547 7.91732C11.4547 7.11274 10.8013 6.45898 9.99341 6.45898ZM7.28213 7.91732C7.28213 6.42071 8.49682 5.20898 9.99341 5.20898C11.49 5.20898 12.7047 6.42071 12.7047 7.91732C12.7047 9.4139 11.49 10.6257 9.99341 10.6257C8.49682 10.6257 7.28213 9.4139 7.28213 7.91732ZM13.2909 14.5909C11.5858 12.7408 8.41124 12.8093 6.70254 14.5989C6.46417 14.8486 6.06855 14.8577 5.81889 14.6194C5.56923 14.381 5.56007 13.9854 5.79844 13.7357C7.97594 11.4551 11.9872 11.3319 14.2101 13.7437C14.444 13.9976 14.4279 14.393 14.1741 14.6269C13.9202 14.8608 13.5248 14.8447 13.2909 14.5909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcNavHomeIcon);
export default __webpack_public_path__ + "static/media/tc_nav_home_icon.d583a603119b30323811aca54dc9a47e.svg";
export { ForwardRef as ReactComponent };